import {
  Box,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import seagullImg from '../images/byd-seagull---carro-eletrico-popular-3.jpg';
import aylaImg from '../images/ayla.webp';
import agyaImg from '../images/agya.jpeg';
import brioImg from '../images/brio.png';
import { Link, Link as RouterLink } from 'react-router-dom';
import bydsealionSpek from '../images/byd-sealion-7-connectivity-24.jpg';
import bydsealionHarga from '../images/byd-sealion-7-connectivity-23.jpg';
import bydsealionRamah from '../images/byd-sealion-7-interior-06.jpg';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';

function Seagull() {
  return (
    <Box
      sx={{ padding: { xs: 2, sm: 4 }, maxWidth: '1200px', margin: '0 auto' }}
    >
      <br />
      <br />
      <br />
      <br />
      <Helmet>
        <title>
          Harga BYD Atto 1 Indonesia 2026 | Spesifikasi dan Perbandingan
        </title>
        <meta
          name='description'
          content='Temukan harga BYD Atto 1 di BYD BSD Serpong, spesifikasi lengkap, fitur, dan perbandingan dengan city car seperti Agya, Ayla, dan Brio.'
        />
        <meta
          name='keywords'
          content='BYD Atto 1, Harga BYD Atto 1 Indonesia, BYD Atto1 BSD Serpong, Mobil Listrik Murah, BYD Atto 1 vs Agya, BYD BSD Serpong'
        />
        <meta
          property='og:title'
          content='Harga BYD Atto 1 Indonesia 2026 | Spesifikasi dan Perbandingan'
        />
        <meta
          property='og:description'
          content='Harga dan spesifikasi BYD Atto 1 lengkap dengan perbandingan city car Agya, Ayla, dan Brio di BYD BSD Serpong.'
        />
        <meta
          property='og:image'
          content='https://bydbsdserpong.com/static/media/byd-seagull---carro-eletrico-popular-3.6129b55707c1bbac318b.jpg'
        />
        <meta
          property='og:url'
          content='https://bydbsdserpong.com/blog/peluncuran-byd-atto1-indonesia'
        />
        <link
          rel='canonical'
          href='https://bydbsdserpong.com/blog/peluncuran-byd-atto1-indonesia'
        />
        <meta property='og:type' content='article' />
        <script type='application/ld+json'>
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BlogPosting',
            headline:
              'Harga BYD Atto 1 Indonesia BYD BSD Serpong - Spesifikasi & Perbandingan Mobil',
            description:
              'Temukan harga dan spesifikasi lengkap BYD Atto 1 di BYD BSD Serpong. Bandingkan dengan Agya, Ayla, dan Brio untuk kebutuhan mobilitas harian.',
            image:
              'https://bydbsdserpong.com/static/media/byd-seagull---carro-eletrico-popular-3.6129b55707c1bbac318b.jpg',
            keywords:
              'BYD Atto1, Harga Mobil Listrik, Mobil Listrik Murah, Atto1 Indonesia, Perbandingan Mobil LCGC',
            articleSection:
              'Mobil Listrik, Perbandingan Mobil, Harga Mobil Murah, Spesifikasi Kendaraan',
            author: {
              '@type': 'Person',
              name: 'BYD BSD Serpong Junius',
              url: 'https://bydbsdserpong.com',
            },
            publisher: {
              '@type': 'Organization',
              name: 'BYD BSD Serpong Junius',
              logo: {
                '@type': 'ImageObject',
                url: 'https://bydbsdserpong.com/static/media/logo.2a151e9e6824f6e000cd.webp ',
              },
            },
            datePublished: '2025-04-03T08:00:00+07:00',
            dateModified: '2026-07-11T08:00:00+07:00',
            mainEntityOfPage: {
              '@type': 'WebPage',
              '@id':
                'https://bydbsdserpong.com/blog/peluncuran-byd-atto1-indonesia',
            },
          })}
        </script>
      </Helmet>
      <Typography variant='h3' component='h1' fontWeight='bold' gutterBottom>
        BYD Atto 1: City Car Listrik Mungil Pesaing Agya, Ayla, dan Brio
      </Typography>

      <Card sx={{ mb: 5 }}>
        <CardMedia
          component='img'
          height='450'
          image={seagullImg}
          alt='BYD Atto1'
        />
        <CardContent>
          <Typography
            variant='body1'
            sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}
          >
            Ini dia “<strong>Atto1</strong>” dari <strong>BYD</strong>, mobil
            listrik mungil yang hadir dengan harga mulai dari{' '}
            <strong>Rp205 juta</strong> di BYD BSD Serpong.
            ✨ Mobil ini punya desain simpel tapi sporty, dibalut warna kuning
            cerah dengan aksen hitam. Cocok banget untuk anak muda yang ingin
            tampil beda.
          </Typography>

          <Typography
            variant='body1'
            sx={{ fontSize: '1.1rem', lineHeight: 1.8, mt: 2 }}
          >
            Dengan jarak tempuh hingga <strong>300 km</strong>, Atto1 bukan
            cuma keren — tapi juga hemat, ramah lingkungan, dan siap menyaingi
            mobil LCGC seperti Agya, Ayla, dan Brio di pasar Indonesia. 💡
          </Typography>
        </CardContent>
      </Card>

      <Grid container spacing={3} sx={{ mb: 6 }}>
        <Grid item xs={12} sm={6}>
          <Paper
            sx={{
              p: 3,
              height: '100%',
              backgroundColor: '#f1f8e9',
              borderLeft: '6px solid #7cb342',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Typography variant='h5' fontWeight='bold' gutterBottom>
              ⚙️ Spesifikasi Singkat
            </Typography>
            <Typography>🔋 Motor listrik 55 kW / 135 Nm</Typography>
            <Typography>🏎️ Kecepatan maksimal 130 km/jam</Typography>
            <Typography>
              🔌 Baterai LFP (BYD Blade), jarak tempuh 300 km
            </Typography>
            <Typography>📏 Dimensi 3.925 x 1.720 x 1.550 mm</Typography>
            <Typography>⚖️ Bobot 1.225-1.280 kg</Typography>
          </Paper>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Paper
            sx={{
              p: 3,
              height: '100%',
              backgroundColor: '#e3f2fd',
              borderLeft: '6px solid #42a5f5',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Typography variant='h5' fontWeight='bold' gutterBottom>
              🌟 Cocok untuk Gen Z & Milenial
            </Typography>
            <Typography>🧠 Desain Compact & Stylish</Typography>
            <Typography>🌱 Ramah Lingkungan & Bebas Emisi</Typography>
            <Typography>
              📲 Fitur digital kekinian: Touchscreen, Smart mode, Remote start
            </Typography>
            <Typography>
              🏙️ Ideal untuk Mahasiswa, Pekerja Muda, & Keluarga Kecil
            </Typography>
          </Paper>
        </Grid>
      </Grid>

      <br />
      <br />
      {/* Spesifikasi Lengkap */}
      {/* Spesifikasi Lengkap */}
      <Paper
        sx={{
          p: 4,
          borderRadius: 3,
          mb: 6,
          backgroundColor: '#fff3e0',
          border: '2px dashed #fb8c00',
        }}
      >
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          Spesifikasi Lengkap BYD Atto 1 NIK 2026
        </Typography>
        <Typography paragraph>
          <strong>🎨 Varian Warna:</strong> White, Sprout Green, Black
        </Typography>
        <Typography paragraph>
          <strong>Harga:</strong> Dynamic Rp205 juta, Premium Rp245 juta
        </Typography>
        <Typography paragraph>
          <strong>Dimensi:</strong> 3.925 x 1.720 x 1.550 mm, radius putar
          4.95 m
        </Typography>
        <Typography paragraph>
          <strong>Performa:</strong> 55 kW, 135 Nm, akselerasi 0–50 km/jam
          dalam 4.9 detik, range 300-380 km NEDC
        </Typography>
        <Typography paragraph>
          <strong>🛡️ Fitur Keamanan:</strong> ABS, EBD, Airbag, VSC, ISOFIX
        </Typography>
        <Typography paragraph>
          <strong>🛋️ Kenyamanan:</strong> Layar 10.1", AC elektrik, 4 speaker,
          OTA update
        </Typography>
        <Typography paragraph>
          <strong>🧠 Lainnya:</strong> Smart pedal, auto-lock, VTOL (Vehicle to
          Load)
        </Typography>
      </Paper>

      <Paper sx={{ p: 4, borderRadius: 3, mb: 5 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          🚘 Hemat Biaya Pakai Mobil Listrik dalam Setahun?
        </Typography>

        <Typography variant='body1' paragraph>
          Salah satu keuntungan utama dari BYD Atto1 adalah biaya operasional
          yang jauh lebih murah dibandingkan mobil bensin konvensional seperti
          Toyota Agya, Daihatsu Ayla, atau Honda Brio 🔋💸.
        </Typography>

        <Typography variant='h6' fontWeight='bold' gutterBottom>
          📊 Simulasi Biaya Operasional Selama 1 Tahun (1.000 km per bulan)
        </Typography>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>🚗 Jenis Mobil</strong>
                </TableCell>
                <TableCell>
                  <strong>⚡ Biaya Energi / BBM</strong>
                </TableCell>
                <TableCell>
                  <strong>🔧 Biaya Servis</strong>
                </TableCell>
                <TableCell>
                  <strong>💰 Total Biaya</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>BYD Atto1 (Listrik)</TableCell>
                <TableCell>± Rp1.500.000 🔋</TableCell>
                <TableCell>± Rp500.000 🛠️</TableCell>
                <TableCell>
                  <strong>± Rp2.000.000</strong>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>LCGC (Agya, Ayla, Brio)</TableCell>
                <TableCell>± Rp7.200.000 ⛽</TableCell>
                <TableCell>± Rp1.500.000 🛠️</TableCell>
                <TableCell>
                  <strong>± Rp8.700.000</strong>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Typography variant='body1' mt={3}>
          Dengan memakai mobil listrik seperti BYD Atto1, kamu bisa hemat
          hingga <strong>Rp6.700.000 per tahun! 💥</strong> Hemat ini bisa kamu
          pakai buat liburan, investasi, atau beli gadget baru 🎁📱.
        </Typography>

        <Typography variant='body2' mt={1} color='text.secondary'>
          *Simulasi ini hanya estimasi. Biaya bisa berbeda tergantung tarif
          listrik, harga BBM, dan kondisi kendaraan.
        </Typography>
      </Paper>

      {/* Simulasi Cicilan */}
      <Paper sx={{ p: 4, borderRadius: 3, mb: 5 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          Simulasi Cicilan BYD Atto1
        </Typography>
        <Typography paragraph>
          Simulasi kredit harga Rp205 juta, DP 20% (Rp41 juta):
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Tenor</strong>
                </TableCell>
                <TableCell>
                  <strong>Angsuran / Bulan</strong>
                </TableCell>
                <TableCell>
                  <strong>Total</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>3 Tahun</TableCell>
                <TableCell>Rp4.000.000</TableCell>
                <TableCell>Rp176.000.000</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>4 Tahun</TableCell>
                <TableCell>Rp3.200.000</TableCell>
                <TableCell>Rp185.600.000</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>5 Tahun</TableCell>
                <TableCell>Rp2.700.000</TableCell>
                <TableCell>Rp194.000.000</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <Typography variant='body2' color='text.secondary' mt={2}>
          *Simulasi bersifat estimasi, tergantung lembaga pembiayaan & profil
          pembeli.
        </Typography>
      </Paper>

      {/* Perbandingan Harga */}
      <Typography variant='h4' fontWeight='bold' gutterBottom>
        Perbandingan dengan LCGC Indonesia
      </Typography>
      <Grid container spacing={4} sx={{ mb: 6 }}>
        {[
          {
            name: 'Toyota Agya',
            image: agyaImg,
            price: 'Rp170,9 Juta - Rp259,3 Juta',
            highlight: '1.2L bensin, manual & CVT',
          },
          {
            name: 'Daihatsu Ayla',
            image: aylaImg,
            price: 'Rp140,3 Juta - Rp196,2 Juta',
            highlight: '1.0L & 1.2L, efisien BBM',
          },
          {
            name: 'Honda Brio',
            image: brioImg,
            price: 'Rp170,4 Juta - Rp258,2 Juta',
            highlight: '1.2L i-VTEC, desain stylish',
          },
        ].map((car, idx) => (
          <Grid item xs={12} sm={4} key={idx}>
            <Card>
              <CardMedia
                component='img'
                height='180'
                image={car.image}
                alt={car.name}
              />
              <CardContent>
                <Typography variant='h6' fontWeight='bold'>
                  {car.name}
                </Typography>
                <Typography variant='body2' color='text.secondary'>
                  {car.price}
                </Typography>
                <Typography variant='body2'>{car.highlight}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Tabel Perbandingan */}
      <Paper sx={{ p: 4, borderRadius: 3, backgroundColor: '#f9f9f9', mb: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          🎓 Dari Para Ahli
        </Typography>
        <Typography variant='subtitle1' gutterBottom>
          💡 Wawasan untuk bantu keputusan terbaikmu:
        </Typography>

        <TableContainer
          component={Paper}
          sx={{ mt: 2, border: '2px solid #1976d2', borderRadius: 2 }}
        >
          <Table>
            <TableHead sx={{ backgroundColor: '#e3f2fd' }}>
              <TableRow>
                <TableCell>
                  <strong>📌 Kategori</strong>
                </TableCell>
                <TableCell align='center'>
                  <strong>🚗 BYD Atto1</strong>
                </TableCell>
                <TableCell align='center'>
                  <strong>🚙 LCGC (Agya, Ayla, Brio)</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }}>
                  👍 Yang Kami Sukai
                </TableCell>
                <TableCell align='center'>
                  <Typography>💰 Harga kompetitif</Typography>
                  <Typography>🧠 Desain modern & unik</Typography>
                  <Typography>🔋 Jarak tempuh 300 km</Typography>
                  <Typography>📲 Fitur digital canggih</Typography>
                </TableCell>
                <TableCell align='center'>
                  <Typography>🛠️ Servis luas & mudah</Typography>
                  <Typography>⛽ Mesin bensin responsif</Typography>
                  <Typography>👨‍👩‍👧‍👦 Cocok untuk keluarga</Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }}>
                  👎 Yang Tidak Kami Sukai
                </TableCell>
                <TableCell align='center'>
                  <Typography>🪑 Material interior biasa saja</Typography>
                  <Typography>📏 Kabin cukup kecil</Typography>
                  <Typography>🔧 Jaringan aftersales terbatas</Typography>
                </TableCell>
                <TableCell align='center'>
                  <Typography>💸 Biaya BBM mahal</Typography>
                  <Typography>🌫️ Emisi karbon tinggi</Typography>
                  <Typography>⚠️ Fitur terbatas di tipe bawah</Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <Paper
        sx={{
          p: 4,
          mt: 8,
          backgroundColor: '#f1f8e9',
          borderLeft: '6px solid #7cb342',
          borderRadius: 2,
        }}
      >
        <Typography variant='h5' fontWeight='bold' gutterBottom>
          🚨 Tertarik dengan BYD Atto1 dan Ingin Segera PO?
        </Typography>
        <Typography variant='body1' gutterBottom>
          Jangan sampai kehabisan! Hubungi Junius sekarang untuk informasi
          lengkap, promo menarik, dan jadwal pre-order unit BYD Atto1 di
          Indonesia. 💬
        </Typography>

        <Box sx={{ mt: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
            <WhatsAppIcon sx={{ color: '#25D366', marginRight: 2 }} />
            <Typography>
              <a
                href='https://api.whatsapp.com/send?phone=6281286864825&text=Halo%20saya%20mau%20tau%20info%20BYD%20nya'
                target='_blank'
                rel='noopener noreferrer'
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                0812 8686 4825
              </a>
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
            <InstagramIcon sx={{ color: '#C13584', marginRight: 2 }} />
            <Typography>
              <a
                href='https://www.instagram.com/bydbsdserpong/'
                target='_blank'
                rel='noopener noreferrer'
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                @bydbsdserpong
              </a>
            </Typography>
          </Box>
        </Box>
      </Paper>
      <Box sx={{ mt: 6 }}>
        <Typography variant='h5' fontWeight='bold' gutterBottom>
          🚗 Tertarik dengan Mobil Listrik Lain dari BYD?
        </Typography>
        <Typography variant='body1' gutterBottom>
          Cek juga artikel lainnya yang membahas mobil listrik canggih dari BYD:
        </Typography>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: '1fr 1fr',
              md: '1fr 1fr 1fr',
            },
            gap: 3,
            mt: 2,
          }}
        >
          {[
            {
              slug: '/blog/spesifikasi-lengkap-byd-sealion-7',
              title: 'Spesifikasi Lengkap BYD Sealion 7',
              image: bydsealionSpek,
            },
            {
              slug: '/blog/harga-byd-sealion-7',
              title:
                'Harga BYD Sealion 7: Apa yang Membuatnya Bernilai Tinggi?',
              image: bydsealionHarga,
            },
            {
              slug: '/blog/byd-sealion-7-ramah-lingkungan',
              title: 'BYD Sealion 7: Mobil Listrik Ramah Lingkungan',
              image: bydsealionRamah,
            },
          ].map((article, index) => (
            <Box
              key={index}
              sx={{
                border: '1px solid #ddd',
                borderRadius: '8px',
                overflow: 'hidden',
                transition: 'transform 0.3s, box-shadow 0.3s',
                '&:hover': {
                  transform: 'scale(1.02)',
                  boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
                },
              }}
            >
              <Link
                component={RouterLink}
                to={article.slug}
                underline='none'
                sx={{ color: 'inherit', textDecoration: 'none' }}
              >
                <Box
                  component='img'
                  src={article.image}
                  alt={article.title}
                  sx={{ width: '100%', height: '160px', objectFit: 'cover' }}
                />
                <Box sx={{ p: 2 }}>
                  <Typography variant='body1' fontWeight='bold'>
                    {article.title}
                  </Typography>
                  <Typography variant='body2' color='textSecondary'>
                    Klik untuk baca lebih lanjut 🔍
                  </Typography>
                </Box>
              </Link>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

export default Seagull;
